import mockData from "./mockData";
import helpers from "./helpers";

const SHOP = helpers.getDomain();
const BASE_URL = `${SHOP}/apps/arcbridge`;
const APP_VERSION = window?.arcBridge?.version || 'v1';

async function getData(path) {
  const url = `${BASE_URL}/${APP_VERSION}/${path}`;

  try {
    const response = await fetch(url);

    if (!response.ok) {
      throw new Error(`Response status: ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    console.error(error.message);
    return { success: false }
  }
}

async function mutateData(path, method, data) {
  const url = `${BASE_URL}/${APP_VERSION}/${path}`;

  try {
    const response = await fetch(url, {
      method,
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data)
    });

    if (!response.ok) {
      throw new Error(`Response status: ${response.status}`);
    }

    return await response.json();

  } catch (error) {
    console.error(error.message);
    return { success: false }
  }
}

export default {
  async getCustomerRewards() {
    return await getData(`omneo/profiles`);
  },

  async getCustomerRewardsHistory() {
    return await getData(`omneo/profiles/history`)
  },

  async getCustomerPreferences() {
    return await getData(`omneo/profiles/preferences`)
  },

  async updateCustomerPreferences(data, payload) {
    return await mutateData(`omneo/profiles/preferences`, 'PUT', data);
  },

  async updateCustomerProfileInformation(data, payload) {
    return await mutateData(`omneo/profiles/information`, 'PUT', data);
  },

  async updateCustomerProfilePreferredStore(data, payload) {
    return await mutateData(`omneo/profiles/preferred-store`, 'PUT', data);
  },
  // async getLocations(params) {
  //   return await getData(`/locations?${params}`);
  //   return mockData.getLocations;
  // },

  // async getLocations({ postcode, delivery_lat, delivery_lng }) {
  //   const params = new URLSearchParams({
  //     postcode,
  //     delivery_lat: String(delivery_lat),
  //     delivery_lng: String(delivery_lng),
  //   });
  
  //   return await getData(`shopify/stores/check?${params.toString()}`);
  // },

  async getLocations({ postcode, delivery_lat, delivery_lng } = {}) {
    const params = new URLSearchParams();
  
    if (postcode) params.append("postcode", postcode);
    if (delivery_lat !== undefined) params.append("delivery_lat", String(delivery_lat));
    if (delivery_lng !== undefined) params.append("delivery_lng", String(delivery_lng));
  
    return await getData(`shopify/stores/check?${params.toString()}`);
  },

  async getClickAndCollectStore({ id, postcode, delivery_lat, delivery_lng }) {
    const params = new URLSearchParams({
      id,
      postcode,
      delivery_lat,
      delivery_lng
    });

    return await getData(`shopify/stores/checkStore?${params.toString()}`);
  },
  async getOrders() {
    return await getData(`endpoints/orders/in-store`);
  }
}